import { EnumBase } from '../models/enum-base.model';

export class TipoDocumentoReadaptacao extends EnumBase {
    constructor() {
        super([
          { value: 'PROJETO_PEDAGOGICO', name: 'Projeto Pedagógico' },
          { value: 'RELATORIO_EXECUCAO', name: 'Relatório de Execução' },
        ]);
    }
}
